import axiosService from './axiosService';

export default {
    /**
     * Captures a screenshot of the given HTML content with specified dimensions.
     *
     * @param {string} html - The HTML content to render and capture as an image.
     * @param {number} [width=600] - The width of the screenshot in pixels. Defaults to 600 if not specified.
     * @param {number} [height=300] - The height of the screenshot in pixels. Defaults to 300 if not specified.
     * @return {Promise<Object>} A promise that resolves to the screenshot data in JSON format.
     */
    async screenshotEmail(html, width = 600, height = 300) {
        const type = 'png';
        const format = 'json';
        return await this.screenshotHTML(html, type, format, width, height);
    },
    /**
     * MLD-7932
     * Captures a screenshot of the provided HTML content and returns it in the specified format.
     *
     * @param {string} html - The HTML content to be rendered and captured in the screenshot.
     * @param {string} [type='png'] - The type of the image to be returned (e.g., 'png', 'jpeg').
     * @param {string} [format='json'] - The format of the response (e.g., 'json', 'base64').
     * @param {number} [width=800] - The width of the viewport for rendering the HTML content.
     * @param {number} [height=600] - The height of the viewport for rendering the HTML content.
     * @return {Promise<Object>} A promise that resolves with the screenshot data returned from the service.
     */
    async screenshotHTML(html, type = 'png', format = 'json', width = 800, height = 300) {
        const form = {
            html,
            type,
            format,
            width,
            height,
        }
        const {data} = await axiosService.post(`/api/browserless/chrome/screenshot`, form);
        return data;
    },
}
